import { computed } from 'vue';
import useMeta from '@modules/discovery/composables/useMeta';
import useDevice from '@modules/discovery/composables/useDevice';
import useEnvParams from '@composables/useEnvParams';
import usePageType from '@modules/discovery/composables/usePageType';
import { IBrandShowcase } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @returns {IBrandShowcase}
 */
export default function useBrandShowcase() {
  const meta = useMeta();
  const { isPhone } = useDevice();
  const propertiesRef = computed(() => meta?.value?.properties ?? {});
  const { isSearch, pageTypeLiteral } = usePageType();
  const { isBcom } = useEnvParams();
  const contextRef = computed(() => meta?.value?.context ?? {});
  const analyticsRef = computed(() => meta?.value?.analytics ?? {});
  const pageIndex = computed(() => analyticsRef.value?.data?.resultsCurrentPage);

  const brandShowcaseConfigRef = computed(() => {
    const { categoryId, searchTerm: contextSearchTerm } = contextRef?.value;
    const { data } = analyticsRef?.value;
    const pageType = pageTypeLiteral;
    const searchTerm = contextSearchTerm ? decodeURI(contextSearchTerm.replace(/%/g, '%25')) : '';

    const config = {
      categoryId,
      pageType,
      parentCategoryId: data?.parentCategoryID,
      topLevelCategoryId: data?.topLevelCategoryID,
      pageIndex,
    };
    /* istanbul ignore else */
    if (isSearch) {
      config.searchTerm = searchTerm;
    }

    return config;
  });

  const siteMonConfig = computed(() => ({
    clientId: 'discovery-xapi',
    device: !isPhone ? 'desktop' : 'mobile',
    isSimplificationOn: !!propertiesRef?.value?.priceSimplificationEnabled,
    brandShowcaseConfig: brandShowcaseConfigRef.value,
  }));
  const brandShowcaseEnabled = computed(() => propertiesRef.value.siteMonBrandShowcaseEnabled);
  const brandShowcaseViewTagEnabled = computed(() => propertiesRef.value.brandShowcaseViewTagEnabled);
  const brandShowcaseClickTagEnabled = computed(() => propertiesRef.value.brandShowcaseClickTagEnabled);
  const carouselOpenInNewTabEnabled = computed(() => propertiesRef.value.carouselOpenInNewTabEnabled);

  return {
    siteMonConfig,
    brandShowcaseEnabled,
    brandShowcaseViewTagEnabled,
    brandShowcaseClickTagEnabled,
    isBcom,
    carouselOpenInNewTabEnabled,
  };
}
